import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

const bioSourceOptions = [
  'Legislative Other Bio',
  'Executive Campaign Bio',
  'Executive Official Bio',
  'Executive Other Bio',
  'Legislative Official Bio',
  'Unknown Other Bio',
  'Legislative Campaign Bio',
  'KnowWho Other Bio'
]

export const BioSourceSelect: React.FC<{ value: string | null, updateBioSource: (bioSource: string | null) => void, disabled: boolean }> = ({ value, updateBioSource, disabled }) => {
  const handleChange = (value: string): void => {
    updateBioSource(value)
  }

  return (
      <FormControl fullWidth variant="outlined">
      <InputLabel id="sourcee-select-label">Bio Source</InputLabel>
      <Select
        label="Bio Source"
        labelId="sourcee-select-label"
        value={value ?? ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        <MenuItem value="">
          None
        </MenuItem>
        {bioSourceOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
